import React from "react";
import BackgroundRings from "../components/BackgroundRings";
import FadeIn from "../components/FadeIn";
import { waUrl } from "../lib/constants";

const About = () => {
    return (
        <main data-testid="about-page">
            {/* PHILOSOPHY */}
            <section
                style={{
                    position: "relative",
                    minHeight: "92vh",
                    display: "flex",
                    alignItems: "center",
                    padding: "160px 32px 100px",
                    overflow: "hidden",
                }}
                data-testid="philosophy-section"
            >
                <BackgroundRings opacity={0.07} position="right" />
                <div
                    style={{
                        maxWidth: 1200,
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >
                    <FadeIn>
                        <p className="eyebrow" style={{ marginBottom: 24 }}>
                            Our Philosophy
                        </p>
                        <h1
                            className="font-serif"
                            data-testid="philosophy-headline"
                            style={{
                                color: "#ffffff",
                                fontSize: "clamp(40px, 6.5vw, 80px)",
                                fontWeight: 400,
                                lineHeight: 1.08,
                                letterSpacing: "-0.02em",
                                marginBottom: 40,
                                maxWidth: 1100,
                            }}
                        >
                            We speak in{" "}
                            <span style={{ color: "#c9a227" }}>
                                sleep, relief, and recovery.
                            </span>
                        </h1>
                        <div
                            style={{
                                color: "#bbb",
                                fontSize: 18,
                                lineHeight: 1.8,
                                maxWidth: 760,
                                fontWeight: 300,
                            }}
                        >
                            <p style={{ marginTop: 0 }}>
                                The Reset Sanctuary was built for people who've
                                tried everything else and still can't switch
                                off. For the parent who hasn't slept. For the
                                athlete whose body won't let go. For the team
                                that's running on empty.
                            </p>
                            <p style={{ marginBottom: 0 }}>
                                We use precision sound recovery —
                                frequencies, transducers, harmonic locks — to
                                move the body from fight-or-flight to
                                rest-and-recover.
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>

            {/* THE FOUNDERS */}
            <section
                style={{
                    padding: "120px 32px",
                    borderTop: "1px solid rgba(201,162,39,0.1)",
                    position: "relative",
                }}
                data-testid="founders-section"
            >
                <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                    <FadeIn>
                        <p
                            className="eyebrow"
                            style={{ marginBottom: 56 }}
                            data-testid="founders-eyebrow"
                        >
                            The Founders
                        </p>
                    </FadeIn>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(300px, 1fr))",
                            gap: 1,
                            backgroundColor: "rgba(201,162,39,0.12)",
                        }}
                    >
                        <FadeIn>
                            <div
                                data-testid="founder-tatva"
                                style={{
                                    backgroundColor: "#0a0a0a",
                                    padding: "44px 36px",
                                    height: "100%",
                                }}
                            >
                                <img
                                    src="/brochure-assets/tatva.png"
                                    alt="Tatva K"
                                    data-testid="founder-tatva-photo"
                                    style={{
                                        width: "100%",
                                        aspectRatio: "4 / 3",
                                        objectFit: "cover",
                                        objectPosition: "center 25%",
                                        border: "1px solid rgba(201,162,39,0.25)",
                                        marginBottom: 28,
                                        display: "block",
                                    }}
                                />
                                <p
                                    className="font-serif"
                                    style={{
                                        color: "#c9a227",
                                        fontSize: 36,
                                        fontWeight: 400,
                                        marginBottom: 6,
                                        lineHeight: 1,
                                    }}
                                >
                                    01
                                </p>
                                <h3
                                    className="font-serif"
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 38,
                                        fontWeight: 400,
                                        marginBottom: 20,
                                        letterSpacing: "-0.02em",
                                    }}
                                >
                                    Tatva K
                                </h3>
                                <p
                                    style={{
                                        color: "#bbb",
                                        fontSize: 16,
                                        lineHeight: 1.75,
                                        marginBottom: 12,
                                        fontWeight: 300,
                                    }}
                                >
                                    Artist. 150M+ aggregate streams. 182K monthly
                                    Spotify listeners.
                                </p>
                                <p
                                    style={{
                                        color: "#bbb",
                                        fontSize: 16,
                                        lineHeight: 1.75,
                                        marginBottom: 12,
                                        fontWeight: 300,
                                    }}
                                >
                                    TEDx Speaker. Tracks Featured on Insight
                                    Timer — the world's largest meditation
                                    app (Forbes, NY Times).
                                </p>
                                <p
                                    style={{
                                        color: "#bbb",
                                        fontSize: 16,
                                        lineHeight: 1.75,
                                        marginBottom: 12,
                                        fontWeight: 300,
                                    }}
                                >
                                    ISTA &amp; IPHM Certified. Reiki
                                    Grandmaster. Berklee College of Music —
                                    Music Therapy Masterclass.
                                </p>
                                <p
                                    style={{
                                        color: "#bbb",
                                        fontSize: 16,
                                        lineHeight: 1.75,
                                        marginBottom: 16,
                                        fontWeight: 300,
                                    }}
                                    data-testid="founder-tatva-press"
                                >
                                    Featured on BBC Radio 1 (Bobby Friction),
                                    BBC Asian Network's Pathaan's Musical
                                    Rickshaw, and Rolling Stone India.
                                    Curated alongside Talvin Singh and DJ
                                    Spooky.
                                </p>
                                <p
                                    style={{
                                        color: "#c9a227",
                                        fontSize: 10.5,
                                        letterSpacing: "0.3em",
                                        textTransform: "uppercase",
                                        margin: "0 0 22px",
                                        fontWeight: 600,
                                    }}
                                    data-testid="founder-tatva-no-ai"
                                >
                                    Hand-produced. Human. No AI.
                                </p>
                                <p
                                    className="font-serif"
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 18,
                                        lineHeight: 1.5,
                                        fontWeight: 400,
                                        margin: 0,
                                    }}
                                >
                                    From Dubai to Ibiza, his sound moved the
                                    world. Now it moves bodies and minds.
                                </p>
                            </div>
                        </FadeIn>
                        <FadeIn delay={120}>
                            <div
                                data-testid="founder-aditya-co"
                                style={{
                                    backgroundColor: "#0a0a0a",
                                    padding: "44px 36px",
                                    height: "100%",
                                }}
                            >
                                <p
                                    className="font-serif"
                                    style={{
                                        color: "#c9a227",
                                        fontSize: 36,
                                        fontWeight: 400,
                                        marginBottom: 6,
                                        lineHeight: 1,
                                    }}
                                >
                                    02
                                </p>
                                <h3
                                    className="font-serif"
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 38,
                                        fontWeight: 400,
                                        marginBottom: 20,
                                        letterSpacing: "-0.02em",
                                    }}
                                >
                                    Aditya Anand
                                </h3>
                                <p
                                    style={{
                                        color: "#c9a227",
                                        fontSize: 11,
                                        letterSpacing: "0.3em",
                                        textTransform: "uppercase",
                                        marginBottom: 20,
                                        fontWeight: 500,
                                    }}
                                >
                                    Direct Access
                                </p>
                                <p
                                    style={{
                                        color: "#bbb",
                                        fontSize: 16,
                                        lineHeight: 1.75,
                                        margin: 0,
                                        fontWeight: 300,
                                    }}
                                >
                                    Sessions, partnerships and access. Every
                                    WhatsApp lands directly with him.
                                </p>
                            </div>
                        </FadeIn>
                    </div>
                </div>
            </section>

            {/* THE TEAM */}
            <section
                style={{
                    padding: "120px 32px",
                    borderTop: "1px solid rgba(201,162,39,0.1)",
                    backgroundColor: "#070707",
                }}
                data-testid="team-section"
            >
                <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                    <FadeIn>
                        <p className="eyebrow" style={{ marginBottom: 20 }}>
                            The Team
                        </p>
                        <h2
                            className="font-serif"
                            style={{
                                color: "#ffffff",
                                fontSize: "clamp(32px, 4.5vw, 56px)",
                                fontWeight: 400,
                                lineHeight: 1.05,
                                letterSpacing: "-0.02em",
                                marginBottom: 48,
                            }}
                        >
                            The Team.
                        </h2>
                    </FadeIn>
                    <FadeIn delay={100}>
                        <div
                            data-testid="team-bmj"
                            style={{
                                border: "1px solid rgba(201,162,39,0.18)",
                                padding: "36px 32px",
                                maxWidth: 560,
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                            }}
                        >
                            <p
                                className="eyebrow"
                                style={{ margin: 0, color: "#c9a227" }}
                            >
                                BMJ
                            </p>
                            <h3
                                className="font-serif"
                                style={{
                                    color: "#ffffff",
                                    fontSize: 30,
                                    fontWeight: 400,
                                    letterSpacing: "-0.01em",
                                    margin: 0,
                                }}
                            >
                                Sumit Beniwal
                            </h3>
                            <p
                                style={{
                                    color: "#bbb",
                                    fontSize: 16,
                                    lineHeight: 1.7,
                                    margin: 0,
                                    fontWeight: 300,
                                }}
                            >
                                ISTA Certified Practitioner.
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>

            {/* THE SPACE */}
            <section
                style={{
                    padding: "120px 32px",
                    borderTop: "1px solid rgba(201,162,39,0.1)",
                }}
                data-testid="space-section"
            >
                <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                    <FadeIn>
                        <p className="eyebrow" style={{ marginBottom: 20 }}>
                            The Space
                        </p>
                        <h2
                            className="font-serif"
                            style={{
                                color: "#ffffff",
                                fontSize: "clamp(36px, 5vw, 64px)",
                                fontWeight: 400,
                                lineHeight: 1.05,
                                letterSpacing: "-0.02em",
                                marginBottom: 56,
                                maxWidth: 700,
                            }}
                        >
                            Where the work happens.
                        </h2>
                    </FadeIn>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(260px, 1fr))",
                            gap: 1,
                            backgroundColor: "rgba(201,162,39,0.1)",
                        }}
                    >
                        {[
                            {
                                t: "Al Hamra, Ras Al Khaimah",
                                d: "Garden sessions under the sky.",
                            },
                            {
                                t: "Al Furjan, Dubai",
                                d: "Urban sanctuary.",
                            },
                            {
                                t: "In-villa, UAE-wide",
                                d: "We come to you.",
                            },
                        ].map((item, i) => (
                            <FadeIn key={i} delay={i * 100}>
                                <div
                                    style={{
                                        backgroundColor: "#0a0a0a",
                                        padding: "44px 32px",
                                        height: "100%",
                                    }}
                                    data-testid={`space-card-${i + 1}`}
                                >
                                    <p
                                        style={{
                                            color: "#c9a227",
                                            fontSize: 11,
                                            letterSpacing: "0.3em",
                                            textTransform: "uppercase",
                                            marginBottom: 16,
                                        }}
                                    >
                                        0{i + 1}
                                    </p>
                                    <h3
                                        className="font-serif"
                                        style={{
                                            color: "#ffffff",
                                            fontSize: 24,
                                            fontWeight: 500,
                                            lineHeight: 1.25,
                                            marginBottom: 12,
                                        }}
                                    >
                                        {item.t}
                                    </h3>
                                    <p
                                        style={{
                                            color: "#888",
                                            fontSize: 15,
                                            lineHeight: 1.6,
                                            margin: 0,
                                        }}
                                    >
                                        {item.d}
                                    </p>
                                </div>
                            </FadeIn>
                        ))}
                    </div>
                </div>
            </section>

            {/* THE METHOD */}
            <section
                style={{
                    padding: "120px 32px",
                    borderTop: "1px solid rgba(201,162,39,0.1)",
                }}
                data-testid="method-section"
            >
                <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                    <FadeIn>
                        <p className="eyebrow" style={{ marginBottom: 20 }}>
                            The Method
                        </p>
                        <h2
                            className="font-serif"
                            style={{
                                color: "#ffffff",
                                fontSize: "clamp(36px, 5vw, 64px)",
                                fontWeight: 400,
                                lineHeight: 1.05,
                                letterSpacing: "-0.02em",
                                marginBottom: 64,
                            }}
                        >
                            Three steps. No friction.
                        </h2>
                    </FadeIn>
                    <div>
                        {[
                            {
                                n: "01",
                                t: "Reserve via WhatsApp.",
                                d: "We'll confirm your slot.",
                            },
                            {
                                n: "02",
                                t: "Arrive.",
                                d: "We discuss what you need. Then direct to the vibroacoustic bed.",
                            },
                            {
                                n: "03",
                                t: "Lie down. Reset.",
                                d: "Leave lighter.",
                            },
                        ].map((s, i) => (
                            <FadeIn key={i} delay={i * 120}>
                                <div
                                    data-testid={`method-step-${i + 1}`}
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "auto 1fr",
                                        gap: 40,
                                        padding: "32px 0",
                                        borderTop:
                                            i === 0
                                                ? "1px solid rgba(201,162,39,0.2)"
                                                : "1px solid rgba(201,162,39,0.1)",
                                        alignItems: "baseline",
                                    }}
                                >
                                    <span
                                        className="font-serif"
                                        style={{
                                            color: "#c9a227",
                                            fontSize: 44,
                                            fontWeight: 400,
                                            minWidth: 72,
                                        }}
                                    >
                                        {s.n}
                                    </span>
                                    <div>
                                        <h3
                                            className="font-serif"
                                            style={{
                                                color: "#ffffff",
                                                fontSize:
                                                    "clamp(24px, 3vw, 36px)",
                                                fontWeight: 400,
                                                lineHeight: 1.2,
                                                marginBottom: 8,
                                            }}
                                        >
                                            {s.t}
                                        </h3>
                                        <p
                                            style={{
                                                color: "#888",
                                                fontSize: 17,
                                                lineHeight: 1.6,
                                                margin: 0,
                                            }}
                                        >
                                            {s.d}
                                        </p>
                                    </div>
                                </div>
                            </FadeIn>
                        ))}
                    </div>
                    <FadeIn delay={500}>
                        <div style={{ marginTop: 56 }}>
                            <a
                                href={waUrl(
                                    "Hi, I'd like to reserve a session after reading your About page.",
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-gold-solid"
                                data-testid="about-reserve-cta"
                            >
                                Reserve via WhatsApp
                            </a>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </main>
    );
};

export default About;
